let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("daAG3")).then(() => parcelRequire('1WGJQ'));